<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("bosch.eventDefinition") }}</label>
        <v-select
          :value="eventDefinitionOptionsFilter"
          :options="eventDefinitionOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:eventDefinitionOptionsFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("bosch.alarmType") }}</label>
        <v-select
          :value="typeAlarmFilter"
          :options="typeAlarmOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:typeAlarmFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("bosch.dispatchAlarm") }}</label>
        <v-select
          :value="dispatchAlarmFilter"
          :options="[{label: 'True', value: true}, {label: 'False', value: false}]"
          class="w-100"
          :multiple="false"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:dispatchAlarmFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("bosch.deviceType") }}</label>
        <v-select
          :value="deviceTypeFilter"
          :options="deviceTypeOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:deviceTypeFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {BCard, BCardHeader, BCardBody, BRow, BCol, BButton} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    eventDefinitionOptions: {
      type: Array,
      default: () => [],
    },
    eventDefinitionOptionsFilter: {
      default: null,
    },
    typeAlarmOptions: {
      type: Array,
      default: () => [],
    },
    typeAlarmFilter: {
      default: null,
    },
    dispatchAlarmFilter: {
      default: null,
    },
    deviceTypeOptions: {
      type: Array,
      default: () => [
        { label: 'Area', value: 'area' },
        { label: 'Output', value: 'output' },
        { label: 'Zone', value: 'zone' }
      ],
    },
    deviceTypeFilter: {
      default: null,
    }
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
